import { Icon } from '@joor/design-system'
import styled from 'styled-components/macro'

type MinimumCheckProps = {
  isMet: boolean
  label: string
}

export function MinimumCheck({ isMet, label }: MinimumCheckProps) {
  return (
    <StatusWrapper>
      {isMet ? (
        <Icon type="semantic" iconSize="small" iconName="success" />
      ) : (
        <Icon
          plain
          iconSize="small"
          iconName="minus-circle-outline"
          className="not-met"
        />
      )}
      <StatusText>{label}</StatusText>
    </StatusWrapper>
  )
}

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  .not-met svg {
    --main-color: var(--color-error-600) !important;
  }
`

const StatusText = styled.div``
